import React, {Suspense, useEffect, useRef, useState} from 'react';
import ModalWrapper from "./ModalWrapper";
import {useDispatch, useSelector} from "react-redux";
import {actionsState as modulesState} from "../Redux/modules";
import {actionsState as projectState} from "../Redux/project";
import * as THREE from "three";
import {sendRedrawEvent, sendRedrawSimpleEvent} from "../Helpers/Events";
import MaterialSelect from "./MaterialSelect";
import {getStrLang} from "../Helpers/functions";

const FloorInfo = ({floor})=>{


    const dispatch = useDispatch();
    const [floorMaterialWnd,setFloorMaterialWnd] = useState(false);
    const [floorMaterial,setFloorMaterial] = useState(floor.material);

    const plan = useSelector(store=>store.project.plan);
    // console.log('FloorInfo')

    const _setFloorMaterial = (m)=>{
        floor.material = m;
        setFloorMaterial(m);
        // console.log('FloorInfo',floor)
        // sendRedrawEvent(document.querySelector('#plan'));
        plan.setFloors();

        sendRedrawSimpleEvent(document.querySelector('#plan'));
    }
    const remove = ()=>{
        ///dispatch(modulesState.remove(module))
    }


    const close = ()=>{
        dispatch(projectState.setModal(''));
    }

    useEffect(()=>{
        // setH(floor.h);
        // setHeight(floor.height);
        // sendRedrawEvent(document.querySelector('#plan'));
    },[floor])

    return  <ModalWrapper
            title={ getStrLang('c3d_3XVhZ') }
            onDelete={()=>remove()}
            onClose={()=>close()}
        >
            <div className="modal-body">
                <div className={"module-image module-image-bg"} style={{backgroundImage: 'url(' + floor.material.userData.PICT + ')'}}></div>
                <div className="material-select-block material-select-block-inline">
                    {window.materials.floor.map(m=>(
                        <div
                            className={m===floor.material?'material-item material-item_active':'material-item'}
                            key={m.uuid}
                            style={{backgroundImage: 'url(' + m.userData.PICT + ')'}}
                            onClick={()=>{_setFloorMaterial(m)}}
                        >
                            {/*<span>{m.userData.NAME}</span>*/}
                        </div>
                    ))}
                </div>

                {/*<div className="materials-block">
                    <div className="options-title">Материал Пола</div>
                    <div className="material-select">
                        <div className="material-select__name">Материал Пола</div>
                        <div className="material-select__select" onClick={()=>setFloorMaterialWnd(true)} style={{backgroundImage: 'url(' + floor.material.userData.PICT + ')',cursor:'pointer'}}>
                            <span>{floor.material.userData.NAME}</span>
                        </div>
                    </div>
                    {floorMaterialWnd === true && <MaterialSelect
                        onClose={()=>setFloorMaterialWnd(false)}
                        active={floor.material}
                        list={window.materials.floor}
                        setMaterial={_setFloorMaterial}
                    />}
                </div>*/}
            </div>
        </ModalWrapper>
}

export default FloorInfo
